import React, { useState, useEffect } from 'react';
import { useCart } from './CartContext'; // Assuming you have a context provider
import { Link } from 'react-router-dom';

function Cart() {
  const { globalCartId } = useCart();
  const [totalCartQty, setTotalCartQty] = useState(0);  // Initialize the state for totalCartQty

  useEffect(() => {
    const cartItems = Array.from(globalCartId.cartContents.values());

    // Calculate the total quantity of items in the cart
    const newTotalCartQty = cartItems.reduce(
      (sum, item) => sum + Number(item.cart_qty), 0
    );

    // Update the state with the new total quantity
    setTotalCartQty(newTotalCartQty);
  }, [globalCartId]);  // Re-run the effect when globalCartId changes

  return (
    <Link to="/cart" style={{ textDecoration: 'none', color: 'inherit' }}>
      <div className='cart-container'>
        <ul className={`cart-floater ${totalCartQty > 0 ? 'pulse' : ''}`}>
          <i className="bi bi-cart2 position-relative" style={{ fontSize: '30px' }}>
            <span style={{ fontSize: '10px' }} className="position-absolute top-0 start-5 translate-middle badge rounded-circle cart-badge">
              {totalCartQty}
            </span>
          </i>
        </ul>
      </div>
    </Link>
  );
}

export default Cart;
